import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-409666ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminSponsors" }
const _hoisted_2 = { id: "showsponsors" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--baseline justify--start" }
const _hoisted_6 = { class: "md2 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "sponsorsContainer"
}
const _hoisted_12 = { class: "display-5 center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "sponsorboks"
}
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = ["id"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "URL:", -1))
const _hoisted_18 = ["id"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_21 = ["id"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette sponsoren?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", null, "Handlingen kan ikke fortrydes")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px"} }, [
        /*#__PURE__*/_createElementVNode("i", null, "* Billedet bliver ikke slettet")
      ])
    ])
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_25 = { class: "editsponsorModal" }
const _hoisted_26 = { class: "md12 flex" }
const _hoisted_27 = {
  class: "mb-4",
  style: {"font-size":"1.2em"}
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Her kan du se og rediger sponsoroplysninger for ")
const _hoisted_29 = { class: "layout gutter--xl" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "flex md6" }
const _hoisted_32 = { class: "flex md6" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "row justify--center" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Vælg billede")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Opdater sponsor")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_39 = { class: "sponsorImageModal" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.5em"} }, "Vælg et billede her", -1))
const _hoisted_41 = { class: "imageFlexBox" }
const _hoisted_42 = ["value"]
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload et nyt billede")
], -1))
const _hoisted_45 = { class: "uploadSection mb-4" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Upload nyt billede")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Brug valgte billede")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_49 = { class: "tabHeight" }
const _hoisted_50 = { id: "newsponsors" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 1,
  class: "form"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "sponsorform-group" }
const _hoisted_55 = { class: "layout gutter--xl" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "flex md6" }
const _hoisted_58 = { class: "flex md6" }
const _hoisted_59 = { class: "row justify--center" }
const _hoisted_60 = { class: "flex" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Vælg billede")
const _hoisted_62 = { key: 0 }
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "row justify--center" }
const _hoisted_65 = { class: "flex" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Opret ny sponsor")
const _hoisted_67 = { class: "sponsorImageModal" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.5em"} }, "Vælg et billede her", -1))
const _hoisted_69 = { class: "imageFlexBox" }
const _hoisted_70 = ["value"]
const _hoisted_71 = ["src"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload et nyt billede")
], -1))
const _hoisted_73 = { class: "uploadSection mb-4" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Upload nyt billede")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Brug valgte billede")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger sponsorer', 'Opret ny sponsor'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil sortering"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetSort()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.sponsorSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sponsorSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findSponsor()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "find_replace" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small resetbutton",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findSponsor()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sponsors, (sponsor, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "sponsorCard",
                  key: sponsor.id
                }, [
                  _createElementVNode("h5", _hoisted_12, _toDisplayString(sponsor.sponsor_sponsornavn), 1),
                  (sponsor.sponsor_billede === null || sponsor.sponsor_billede === '' || sponsor.sponsor_billede === undefined)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Ikke noget billede"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("img", {
                          class: "sponsorLogo",
                          src: _ctx.mediaBaseURL + sponsor.sponsor_billede.url,
                          alt: sponsor.sponsor_sponsornavn + ' Logo',
                          width: "250"
                        }, null, 8, _hoisted_15)
                      ])),
                  _createElementVNode("p", {
                    class: "center sponsorURL",
                    id: 'sponsortable-row' + (index+1)
                  }, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(sponsor.sponsor_link), 1)
                  ], 8, _hoisted_16),
                  _createElementVNode("div", {
                    class: "sponsor_buttons",
                    id: 'sponsortable-row' + (index+1)
                  }, [
                    _createVNode(_component_va_divider),
                    _createVNode(_component_va_button_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_button, {
                          class: "btn",
                          color: "info",
                          name: "editsponsor",
                          onClick: ($event: any) => (_ctx.editSponsor(sponsor.documentId))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_va_button, {
                          class: "btn status-width",
                          icon: sponsor?.sponsor_status ? 'check_box' : 'check_box_outline_blank',
                          color: sponsor?.sponsor_status ? 'success' : 'rgb(255, 172, 10)',
                          name: "statusSponsor",
                          onClick: ($event: any) => (_ctx.blockSponsor(sponsor.id, sponsor.documentId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sponsor?.sponsor_status ? 'Aktiv' : 'Inaktiv'), 1)
                          ]),
                          _: 2
                        }, 1032, ["icon", "color", "onClick"]),
                        _createVNode(_component_va_button, {
                          class: "btn",
                          color: "danger",
                          name: "deletesponsor",
                          onClick: ($event: any) => (_ctx.deleteSponsorWarning(sponsor.documentId))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ], 8, _hoisted_18),
                  _createElementVNode("div", {
                    class: "sponsor_frontpage_button center mt-4",
                    id: 'sponsortable-row' + (index+1)
                  }, [
                    _createVNode(_component_va_button, {
                      class: "btn sponsor-width",
                      icon: sponsor?.sponsor_forside ? 'check_box' : 'check_box_outline_blank',
                      color: sponsor?.sponsor_forside ? 'success' : 'rgb(255, 172, 10)',
                      name: "frontpageStatus",
                      onClick: ($event: any) => (_ctx.frontPageSponsor(sponsor.id, sponsor.documentId))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sponsor?.sponsor_forside ? 'På forsiden' : 'Ikke på forsiden'), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon", "color", "onClick"])
                  ], 8, _hoisted_21)
                ]))
              }), 128))
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteSponsorWarningModal,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.deleteSponsorWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteSponsor(this.deleteSponsorId), _ctx.$Message.success({ text: 'Sponsoren er blevet slettet'})))
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteSponsorWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret'})))
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editSponsorModal,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editSponsorModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$Message.success({ text: 'Gemt succesfuldt' }), (_ctx.editSponsorModal = false), _ctx.updateSponsor()))
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "secondary",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev anulleret' }), (_ctx.editSponsorModal = false), _ctx.cancelSponsorEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.sponsorData.sponsorNavn), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_va_input, {
                      class: "mb-4",
                      type: "text",
                      modelValue: _ctx.sponsorData.sponsorNavn,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sponsorData.sponsorNavn) = $event)),
                      label: "Sponsornavn",
                      bordered: "",
                      rules: [(sponsorNavn) =>_ctx.sponsorData.sponsorNavn.length > 1 || 'Der mangler et sponsornavn']
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_va_input, {
                      class: "mb-4",
                      type: "text",
                      modelValue: _ctx.sponsorData.sponsorURL,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sponsorData.sponsorURL) = $event)),
                      label: "Sponsorhjemmeside",
                      bordered: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (_ctx.sponsorData.sponsorLogo !== undefined)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "sponsorLogo",
                      src: _ctx.mediaBaseURL + _ctx.sponsorData.sponsorLogo.url,
                      width: "250",
                      height: "250"
                    }, null, 8, _hoisted_33))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_va_button, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editImageModal = !_ctx.editImageModal))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.editImageModal,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editImageModal) = $event)),
              title: "Vælg sponsorbillede",
              size: "large",
              "hide-default-actions": "",
              "overlay-opacity": "0.5",
              "no-dismiss": ""
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "mr-4",
                  color: "success",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.useSelectedImage()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_47
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  color: "secondary",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$Message.warning({ text: 'Intet billede valgt' }), (_ctx.editImageModal = false), _ctx.cancelImage()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOnlyImages(), (media, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "imageContainer",
                        key: index
                      }, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedSponsorImage) = $event)),
                            class: "sponsorRadio",
                            type: "radio",
                            name: "choosenImage",
                            value: media
                          }, null, 8, _hoisted_42), [
                            [_vModelRadio, _ctx.selectedSponsorImage]
                          ]),
                          _createElementVNode("img", {
                            src: _ctx.mediaBaseURL + media.url,
                            width: "150",
                            height: "150"
                          }, null, 8, _hoisted_43)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_va_divider),
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("input", {
                      class: "mb-4",
                      type: "file",
                      onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                    }, null, 32),
                    _createVNode(_component_va_button, {
                      class: "btn",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onUpload()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_46
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger sponsorer']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newsponsorform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.sponsorData.sponsorNavn,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.sponsorData.sponsorNavn) = $event)),
                                    type: "text",
                                    label: "Sponsornavn",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.sponsorData.sponsorURL,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sponsorData.sponsorURL) = $event)),
                                    type: "text",
                                    label: "Sponsorlink",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createVNode(_component_va_button, {
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.imageModal = !_ctx.imageModal))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_61
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.sponsorData.sponsorLogo.url !== undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                        _createElementVNode("img", {
                                          src: _ctx.mediaBaseURL + _ctx.sponsorData.sponsorLogo.url,
                                          width: "250",
                                          height: "250"
                                        }, null, 8, _hoisted_63)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.createSponsor()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_66
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.imageModal,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.imageModal) = $event)),
            title: "Vælg sponsorbillede",
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_va_button, {
                class: "mr-4",
                color: "success",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.useSelectedImage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_75
                ]),
                _: 1
              }),
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$Message.warning({ text: 'Intet billede valgt' }), (_ctx.imageModal = false), _ctx.cancelImage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_76
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOnlyImages(), (media, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "imageContainer",
                      key: index
                    }, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedSponsorImage) = $event)),
                          class: "sponsorRadio",
                          type: "radio",
                          name: "choosenImage",
                          value: media
                        }, null, 8, _hoisted_70), [
                          [_vModelRadio, _ctx.selectedSponsorImage]
                        ]),
                        _createElementVNode("img", {
                          src: _ctx.mediaBaseURL + media.url,
                          width: "150",
                          height: "150"
                        }, null, 8, _hoisted_71)
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_va_divider),
                _hoisted_72,
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("input", {
                    class: "mb-4",
                    type: "file",
                    onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                  }, null, 32),
                  _createVNode(_component_va_button, {
                    class: "btn",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onUpload()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_74
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny sponsor']
      ])
    ])
  ]))
}